export default function Footer() {
    return (
        <div className="bg-gradient-to-r from-amber-600 via-orange-600 to-red-600 rounded-b-lg p-6 text-white text-center shadow-xl">
            <p className="text-sm">
                For questions, contact <a href="tel:0794757795" className="underline">079 475 77 95</a>
            </p>
            <p className="text-xs mt-2 opacity-90">
                We look forward to celebrating this special occasion with you
            </p>
        </div>
    );
}